import HttpService from "@core/services/http/http.service";
import { Signal } from "@core/services/http/http.type";
import {
  BookInteraction,
  BookPurchase,
  GeneralInformation,
  RequestParamsDashboard,
  BookRevenue,
} from "@app/types/dashboard.type";
import { GetDetailResponse } from "@app/types";

class _DashboardService {
  public getGeneralInformation(
    requestParams?: RequestParamsDashboard,
    signal?: Signal
  ) {
    return HttpService.get<GetDetailResponse<GeneralInformation>>(
      "/admin/api/v3/dashboard-author/general-information",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public getBookPurchase(
    requestParams?: RequestParamsDashboard,
    signal?: Signal
  ) {
    return HttpService.get<GetDetailResponse<BookPurchase>>(
      "/admin/api/v3/dashboard-author/book-purchase",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public getBookInteractions(
    requestParams?: RequestParamsDashboard,
    signal?: Signal
  ) {
    return HttpService.get<GetDetailResponse<BookInteraction>>(
      "/admin/api/v3/dashboard-author/book-interactions",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }
}

class _DashboardAuthorService {
  public getBookRevenueRetail(
    requestParams?: RequestParamsDashboard,
    signal?: Signal
  ) {
    return HttpService.get<GetDetailResponse<BookRevenue>>(
      "/admin/api/v3/dashboard-author/book-revenue-retail",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public getBookRevenueVip(
    requestParams?: RequestParamsDashboard,
    signal?: Signal
  ) {
    return HttpService.get<GetDetailResponse<BookRevenue>>(
      "/admin/api/v3/dashboard-author/book-revenue-vip",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }
}

const DashboardService = new _DashboardService();

export const DashboardAuthorService = new _DashboardAuthorService();

export default DashboardService;
